import { render } from "./MainLayoutHeader.vue?vue&type=template&id=650125e2"
import script from "./MainLayoutHeader.vue?vue&type=script&lang=js"
export * from "./MainLayoutHeader.vue?vue&type=script&lang=js"

import "./MainLayoutHeader.vue?vue&type=style&index=0&id=650125e2&lang=css"

import exportComponent from "/home/vsts/work/1/s/share.filevaultcore.com/share.filevaultcore.com/share.filevaultcore.spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__